export default __webpack_public_path__ + "static/media/arrow.d2c9da57.svg";